import {
  navElements,
  CMSPath,
  // compType
} from '../../config/constant'

const sortByPositionHandler = (navItems) => {

  let sortedNavItems = [];

  if(!navItems || navItems.length === 0){
    return sortedNavItems;
  }

  sortedNavItems = [...navItems]
  sortedNavItems.sort((a,b) => a.position > b.position ? 1 : -1)

  return sortedNavItems;
}

export const mapComponentToNavItem = (props, navBarItem, compType) => {
  let currentObj;
  //console.log("mapComponentToNavItem",navBarItem);
  let appLauncherWid = props.appLauncherWidget;
  let currentDisplayName, currentWidgetType, navItem = [];
  let status = true, toggle = true;
  if (navBarItem) {
    navBarItem.map((iterator, index) => {
      currentWidgetType = iterator.widgetType.toLowerCase();
      currentDisplayName = iterator.displayName.toLowerCase();
      for (let i = 0; i < compType.length && status === true; i++) {
        for (let j = 0; j < compType[i].alterNativeName.length; j++) {
          if (currentWidgetType === compType[i].alterNativeName[j]) {
            currentObj = {
              ...iterator,
              path: compType[i].path,
              include: toggle,
              alterNativeName: compType[i].alterNativeName,
              compName: compType[i].compName,
              compImage: iterator.btnImageUrl ? `${CMSPath}${iterator.btnImageUrl}` : compType[i].image,
            }
            navItem.push(currentObj);
            status = false;
            break;
          }
          //if ()
        }
      }
      if (currentWidgetType === "IPTV" || currentWidgetType === "iptv") {
        props.setTVtype("IPTV");
      }
      if (currentWidgetType === "applauncher" ||
        currentWidgetType === "app launcher" ||
        currentWidgetType === "App Launcher" ||
        currentWidgetType === "launcher" ||
        currentWidgetType === "crestron" ||
        currentWidgetType === "Launcher") {
        appLauncherWid.push(props.MasterWidget.widgets[iterator.widgetTypeId]);
      }
      status = true;
    })
  }
  props.setNavItem(navItem);
  props.setLauncherWidget(appLauncherWid);
  return navItem;
}

// Milind: Method to process the ScrollingWidget object and store into redux store.
export const mapScrollingWidgetComponentToNavItem = (props, navBarItem, compType) => {

  let updatedWidgetList = null, copyNavBarItem = [];
  //console.log("mapComponentToNavItem",navBarItem);

  // let explore = getWidgetSelector(navBarItem, 'explore')
  // let mystay = getWidgetSelector(navBarItem, 'mystay')

  // let navItemExplore = processWidgetsSelector(props, explore, compType);
  // let navItemMystay = processWidgetsSelector(props, mystay, compType);

  // props.setNavItemExplore(navItemExplore);
  // props.setNavItemMystay(navItemMystay);

  //return navItem; 

  /**
   * this is mapping of widget component to its widget in widget list from CMS.
   */
  if (navBarItem && navBarItem.length > 0) {    
    copyNavBarItem = [...navBarItem]

    navBarItem.map((item, index) => {
      updatedWidgetList = processWidgetsSelector(props, item.widgets, compType);
      copyNavBarItem[index].widgets = updatedWidgetList
    })

    props.setNavItemList(copyNavBarItem);


    if(props.selectedNav && Object.keys(props.selectedNav).length  > 0){

      const selectedNavWidgList = copyNavBarItem.find(
        (item) =>
          item.uniqueKey === props.selectedNav.uniqueKey || 
          item.uniqueKey === props.selectedNav.tabName.replace(/ /g, '').toLowerCase()
      );
      
      if (selectedNavWidgList) {
        props.setCurrentTabNavItemList(selectedNavWidgList.widgets);
      }
    }
  }
}

export const floatingWidgetComp = (props, widgetInfo, compType) => {
  let updatedFloatingWidget = null;

  let widgets = [{
    subWidgetMap: [widgetInfo]
  }]

  updatedFloatingWidget = processWidgetsSelector(props, widgets, compType);

  return updatedFloatingWidget;
} 


const getWidgetSelector = (state, compType) => {

  var widgets = [];

  state.map((obj) => {

    if (obj.uniqueKey === compType) {
      widgets = obj.widgets
    }
  })

  return widgets
}

const processWidgetsSelector = (props, widgets, compType) => {

  let appLauncherWid = props.appLauncherWidget;
  let currentDisplayName, currentWidgetType, navItem = [];
  let status = true, toggle = true;
  let currentObj;

  widgets.map((widget, index) => {

    let subWidgetsArray = [];
    // console.log('before SubWidget = ', widget.subWidgetMap);
    widget.subWidgetMap.map((subWidget, i) => {

      currentWidgetType = subWidget.widgetType.toLowerCase();
      currentDisplayName = subWidget.displayName.toLowerCase();
      for (let i = 0; i < compType.length && status === true; i++) {
        for (let j = 0; j < compType[i].alterNativeName.length; j++) {
          if (currentWidgetType === compType[i].alterNativeName[j]) {
            currentObj = {
              ...subWidget,
              path: compType[i].path,
              include: toggle,
              alterNativeName: compType[i].alterNativeName,
              compName: compType[i].compName,
              compImage: subWidget.btnImageUrl ? `${CMSPath}${subWidget.btnImageUrl}` : compType[i].image,
            }

            if(currentWidgetType == "restaurant reservation"){
              if(props.restaurantReservationInterfaceCode == "SEVENROOMS"){
                currentObj = {...currentObj, path: "/resReservationV2"}
              }
            }

            subWidgetsArray.push(currentObj);
            status = false;
            break;
          }
        }
      }

      if(status){
        console.log("this widget is not supported", subWidget.widgetType);
        currentObj = {
          ...subWidget,
          path: "",
          widgetType: "Widget Not Supported",
          include: toggle,
          compImage: subWidget.btnImageUrl ? `${CMSPath}${subWidget.btnImageUrl}` : compType[i].image,
        }
        subWidgetsArray.push(currentObj);
        status = false;
      }
      
      // console.log('after SubWidget = ', subWidgetsArray)
      if (currentWidgetType === "IPTV" || currentWidgetType === "iptv") {
        props.setTVtype("IPTV");
      }
      if (currentWidgetType === "applauncher" ||
        currentWidgetType === "app launcher" ||
        currentWidgetType === "App Launcher" ||
        currentWidgetType === "launcher" ||
        currentWidgetType === "crestron" ||
        currentWidgetType === "Launcher"|| 
        currentWidgetType === "youtube" ||
        currentWidgetType === "chrome" ||
        currentWidgetType === "applauncher2" ||
        currentWidgetType === "applauncher3" ||
        currentWidgetType === "applauncher4" ||
        currentWidgetType === "applauncher5") {
          widget.subWidgetMap.map((subWidget) => {
            appLauncherWid.push(props.MasterWidget.widgets[subWidget.widgetTypeId]);
          })
      }
      status = true;

    })

    currentObj = {
      ...widget,
      subWidgetMap: subWidgetsArray,
    }
    navItem.push(currentObj);
  })

  console.log("props navItem",navItem)

  if(props.setNavItem) props.setNavItem(sortByPositionHandler(navItem));

  // remove duplicates from appLauncherWid;
  const uniqueAppLauncherWidSet = new Set(appLauncherWid);
  const uniqueAppLauncherWid = Array.from(uniqueAppLauncherWidSet);

  if(props.setLauncherWidget) props.setLauncherWidget(uniqueAppLauncherWid);

  return navItem;
}

/*obj = {
  widgetType: iterator.widgetType,
  path: compType[i].path,
  alterNativeName: compType[i].alterNativeName,
  compImage: iterator.btnImageUrl ? `${CMSPath}${iterator.btnImageUrl}` : compType[i].image,
  compName: compType[i].compName,
  position: iterator.position,
  include: toggle,
  id: iterator.id
}
else
if (currentWidgetType === "url renderer") {
  console.log("@@@", currentWidgetType);
  if (currentWidgetTypec === ompType[i].alterNativeName[j]) {
    console.log("url renderer");
    currentObj = {
      ...iterator,
      path: compType[i].path,
      include: toggle,
      alterNativeName: compType[i].alterNativeName,
      compName: compType[i].compName,
      compImage: iterator.btnImageUrl ? `${CMSPath}${iterator.btnImageUrl}` : compType[i].image,
    }
    navItem.push(currentObj);
    status = false;
    //toggle = !toggle
    break;
  }
}*/
